import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import css from './css.module.less';
import { Form } from 'src/components/RcForm';
import { get } from 'lodash';
import { checkAll } from './validator';
import {
  name,
  // alwaysOn,
  // beginDate,
  // beginTime,
  // endDate,
  // endTime,
  _timeSettings,
} from 'src/tools/contentModulesFieldName';
//import { useDebounce } from 'src/tools/customHooks';

const ErrorDisplay = (props) => {
  const nameOnForm = Form.useWatch(name, props.form);
  const timeOnForm = Form.useWatch(_timeSettings, props.form);

  const savedName = get(props.data, name);
  const savedTime = get(props.data, _timeSettings);

  const res = checkAll(
    props.selected
      ? { name: nameOnForm, ...timeOnForm }
      : { name: savedName, ...savedTime },
  );
  const hasError = get(res, 'hasError');

  return hasError ? <InfoCircleFilled rev className={css.iconWarn} /> : null;
};
export default ErrorDisplay;
